import React from "react";
import ConnectionPair from "root/Components/ConnectionContainer/ConnectionPair";

const ConnectionsContainer = ({loading, data, userId, clickHandler}) => {

    const createConnectionPairs = () =>
    {
        if(data[0].length !== 0)
        {
            let connection_pair = [];
            let pairsData = [];
            let workingData = [];

            //Make a copy of the data to work with
            for (let i = 0; i < data.length; i++)
            {
                workingData[i] = data[i];
            }

            //step through and create pairs of data
            for (let i = 0; i < workingData.length; i++)
            {
                connection_pair.push(workingData[i])

                //Find matching pair
                for (let j = 0; j < workingData.length; j++)
                {
                    if (workingData[i].ur_idusers_raw === workingData[j].ur_relation_idusers_raw && workingData[i].ur_relation_idusers_raw === workingData[j].ur_idusers_raw)
                    {

                        //Need to check if the subject is the first record - then we put found record first
                        if (connection_pair[0]['ur_idusers_raw'] == userId)
                        {
                            connection_pair.unshift(workingData[j])
                        }
                        else
                        {
                            connection_pair.push(workingData[j])
                        }

                        workingData.splice(j, 1);
                        break
                    }
                }

                pairsData.push(connection_pair)

                connection_pair = [];
            }

            return renderConnectionPairs(pairsData);
        }
    }

    const renderConnectionPairs = (pairsData) =>
    {
        return pairsData.map ((connectionPair, index) => {
            return (
                <ConnectionPair data={connectionPair} key={connectionPair[0].ur_id} clickHandler={clickHandler} />
            )
        });
    }

    return(
        <div className="connection-body">
            {createConnectionPairs()}
        </div>
    )

    //return loading === true ? <SpinnerDiv/> : thisContent();
};

export default ConnectionsContainer;
